const getCopyrightAsString = (layers) => {
  const copyrights = [];

  layers
    .filter((layer) => {
      return (
        layer.getVisible() &&
        layer.getSource?.()?.getAttributions?.()?.().length > 0
      );
    })
    .forEach((layer) => {
      const attributions = layer.getSource().getAttributions()?.();
      attributions.forEach((copyright) => {
        // If copyright is HTML
        if (/^</.test(copyright)) {
          const parsed = new DOMParser().parseFromString(
            copyright,
            "text/html",
          );
          [...parsed.getElementsByTagName("a")].forEach((tag) => {
            return copyrights.push(tag.text);
          });
        } else {
          // If copyright is only text
          copyrights.push(copyright);
        }
      });
    });
  const unique = Array.from(new Set(copyrights));
  return unique.join(" | ");
};

export default getCopyrightAsString;
